/**
 * Update User Details Form
 */
import React, {  Fragment }  from 'react';
import { Form, FormGroup, Label, Input, FormFeedback } from 'reactstrap';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Switch from '@material-ui/core/Switch';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
//import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import TextField from '@mui/material/TextField';
import dayjs, { Dayjs } from 'dayjs';
import 'dayjs/locale/es';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { MobileDateTimePicker } from '@mui/x-date-pickers/MobileDateTimePicker';
import { DateTimePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns'; // choose your lib
import esLocale from "date-fns/locale/es";

const UpdateControlForm = ({ control, onUpdateControlDetail, addNewControlDetails, onBlurRut, onFocusRut, index, validate , maxDate}) => (
    <Form>
        
         <FormGroup>
            <Label className="mb-1" for="tipo_con">Tipo de control</Label>
            <FormControl fullWidth>
                <Select disabled={true} readOnly  name="tipo_con" name="tipo_con" value={control.tipo_con} onChange={(e) => onChangeAddNewControlDetails('tipo_con', e.target.value)}
                >
                      <MenuItem value=''>Seleccione</MenuItem>  
                      <MenuItem value={'PERSONAS'}>PERSONAS</MenuItem>
                      <MenuItem value={'VEHÍCULOS'}>VEHÍCULOS</MenuItem>
                      <MenuItem value={'CAMIONES'}>CAMIONES</MenuItem>
                      <MenuItem value={'EMBARCACIONES'}>EMBARCACIONES</MenuItem>
                </Select>
              </FormControl>
        </FormGroup>
        {control.tipo_con === 'PERSONAS' &&
        <FormGroup>
        
            <Label for="controlRut">Rut</Label>
            <Input
                disabled={true}
                readOnly 
                type="text"
                name="controlRut"
                id="userRut"
                placeholder="Ingrese RUT"
                invalid={validate.rutState === "has-danger"}
                value={control.rut}
                onFocus={(e) => onFocusRut(e.target.value,'editar')}
                onBlur={(e) => onBlurRut(e.target.value,'editar')}
                onChange={(e) => onUpdateControlDetail('rut', e.target.value)}
            />
            <FormFeedback>
              RUT incorrecto, o dígito verificador no corresponde
            </FormFeedback>
        </FormGroup>
        }
        {control.tipo_con === 'VEHÍCULOS' &&
        <FormGroup>
            <Label for="controlRutChofer">Rut Chofer</Label>
            <Input
                disabled={true}
                readOnly 
                type="text"
                name="controlRutChofer"
                id="userRutChofer"
                placeholder="Ingrese RUT"
                invalid={validate.rutChoferState === "has-danger"}
                value={control.rut_chofer}
                onFocus={(e) => onFocusRutChofer(e.target.value,'nuevo')}
                onBlur={(e) => onBlurRutChofer(e.target.value,'nuevo')}
                onChange={(e) => onUpdateControlDetail('rut_chofer', e.target.value)}
            />
            <FormFeedback>
              RUT incorrecto, o dígito verificador no corresponde
            </FormFeedback>
        </FormGroup>
        }
       
        <FormGroup>
            <Label for="userName">Nombre</Label>
            <Input
                disabled={true}
                readOnly 
                type="text"
                name="ControlName"
                id="controlName"
                invalid={validate.nameState === "has-danger"}
                placeholder="Ingrese Nombre"
                value={control.nom_per}
                onChange={(e) => onUpdateControlDetail('nom_per', e.target.value)}
            />
            <FormFeedback>
              Nombre no puede ser vacío o muy corto.
            </FormFeedback>
        </FormGroup>
        {(control.tipo_con === 'VEHÍCULO' || control.tipo_con === 'EMBARCACIONES') &&
       <FormGroup>
            <Label for="controlPate">Patente/Matrícula</Label>
            <Input
                disabled={true}
                readOnly 
                type="text"
                name="ControlPate"
                id="controlName"
                invalid={validate.nameState === "has-danger"}
                placeholder="Ingrese Patente o Matrícula"
                value={control.pate}
                onChange={(e) => onUpdateControlDetail('pate', e.target.value)}
            />
            <FormFeedback>
              Patente/Matrícula no puede ser vacío o muy corto.
            </FormFeedback>
            
        </FormGroup>
        }
         <FormGroup>
            <Label for="h_in">Fecha Inicio</Label>
                <FormGroup>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                        <DateTimePicker
                                clearable
                                readOnly
                                ampm={true}
                                maxDate={maxDate}
                                inputVariant="outlined"
                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                fullWidth
                                format="dd/MM/yyyy HH:mm a"
                                value={control.h_in}
                                onChange={(e) => onUpdateControlDetail('h_in', e)}
                                />
                    </MuiPickersUtilsProvider>    
                </FormGroup>
        </FormGroup>
        <FormGroup  >
            <Label for="h_sal">Fecha salida</Label>
                <FormGroup>
                <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
                        <DateTimePicker
                                clearable
                                readOnly={control.estado == 2} 
                                ampm={true}
                                inputVariant="outlined"
                                leftArrowIcon={<i className="zmdi zmdi-arrow-back" />}
                                rightArrowIcon={<i className="zmdi zmdi-arrow-forward" />}
                                fullWidth
                                maxDate={maxDate}
                                format="dd/MM/yyyy HH:mm a"
                                value={control.h_sal}
                                onChange={(e) => onUpdateControlDetail('h_sal', e)}
                                />
                    </MuiPickersUtilsProvider>   
                </FormGroup>
        </FormGroup>
       {control.tipo_con === 'PERSONAS' &&
       <FormGroup>
          <Label for="entre">Entrevista</Label>
            <Input
                disabled={true}
                readOnly 
                type="text"
                name="entre"
                id="entre"
                placeholder="Ingrese entrevistado"
                value={control.entre}
                onChange={(e) => onUpdatecontrolDetail('entre', e.target.value)}
            />
       
       </FormGroup>
       }
       {  control.tipo_con === 'EMBARCACIONES' &&
         <FormGroup>
          <Label for="nombre_naviera">Nombre Naviera</Label>
            <Input
                disabled={true}
                readOnly 
                type="text"
                name="nombre_naviera"
                id="nombre_naviera"
                placeholder="Ingrese nombre naviera"
                value={control.nombre_naviera}
                onChange={(e) => onUpdateControlDetail('nombre_naviera', e.target.value)}
            />
       
       </FormGroup>
       }
       {  control.tipo_con === 'EMBARCACIONES' &&
         <FormGroup>
          <Label for="tipo_movimiento">Tipo Movimiento</Label>
            <FormControl fullWidth>
                <Select disabled={true} readOnly name="tipo_movimiento" name="tipo_movimiento" value={control.tipo_movimiento} onChange={(e) => onUpdateControlDetail('tipo_movimiento', e.target.value)}
                >
                      <MenuItem value=''>Seleccione</MenuItem>  
                      <MenuItem value={'RETIRO'}>RETIRO</MenuItem>
                      <MenuItem value={'INGRESO'}>INGRESO</MenuItem>
                </Select>
              </FormControl>
       
       </FormGroup>
       }
       {(control.tipo_con === 'CAMIONES' || control.tipo_con === 'EMBARCACIONES') &&
         <FormGroup>
          <Label for="guia_des">Guia Despacho</Label>
            <Input
                disabled={true}
                readOnly 
                type="number"
                name="guia_des"
                id="guia_des"
                placeholder="Ingrese guia despacho"
                value={control.guia_des}
                onChange={(e) => onUpdateControlDetail('guia_des', e.target.value)}
            />
       
       </FormGroup>
       }
       {control.tipo_con === 'CAMIONES' &&
        <FormGroup>
          <Label for="sello">Sello</Label>
            <Input
                disabled={true}
                readOnly 
                type="number"
                name="sello"
                id="sello"
                placeholder="Ingrese sello"
                value={control.sello}
                onChange={(e) => onUpdateControlDetail('sello', e.target.value)}
            />
       
       </FormGroup>
       }
       {control.tipo_con === 'CAMIONES' &&
        <FormGroup>
          <Label for="espe">Especie</Label>
            <Input
                disabled={true}
                readOnly
                type="text"
                name="espe"
                id="espe"
                placeholder="Ingrese especie"
                value={control.espe}
                onChange={(e) => onUpdateControlDetail('espe', e.target.value)}
            />
       
       </FormGroup>
       }
       {control.tipo_con === 'CAMIONES'  &&
         <FormGroup>
          <Label for="canda">Candado</Label>
            <Input
                disabled={true}
                readOnly
                type="number"
                name="canda"
                id="canda"
                placeholder="Ingrese candado"
                value={control.canda}
                onChange={(e) => onUpdateControlDetail('canda', e.target.value)}
            />
       
       </FormGroup>
       }
       <FormGroup>
          <Label for="entre">{control.interno == 1 ? 'Interno' : 'Externo'}</Label>
            <FormControl fullWidth>
                <Switch disabled={true} readOnly  name="interno" color="primary" id="interno" checked={(control.interno === 1 || control.interno === true) ? true : false } 
                onChange={(e) => onUpdatecontrolDetail('interno', e.target.checked)} aria-label="interno" />
              </FormControl>
       </FormGroup>
    </Form>
);

export default UpdateControlForm;
